module.exports = __webpack_public_path__ + "img/column.ad589324.svg";